import { getElementScreenCenter } from '@cointracker/styleguide';
import { SnapState } from '@cointracker/styleguide/src/SnapPoint/context';
import { useEffect, useRef, useState } from 'react';

export const useFeatureState = (): {
  ref: React.RefObject<HTMLDivElement>;
  state: SnapState;
} => {
  const ref = useRef<HTMLDivElement>(null);
  const [state, setState] = useState(SnapState.BEFORE);

  useEffect(() => {
    if (!ref.current) return;

    let animationFrame: number;

    const handleScroll = () => {
      if (!ref.current) return;

      const scroll = window.scrollY || document.documentElement.scrollTop;
      animationFrame = requestAnimationFrame(handleScroll);

      const rect = ref.current.getBoundingClientRect();

      const centerScroll = getElementScreenCenter(ref);
      const topScroll = centerScroll - (rect.height / 3) * 2;
      const bottomScroll = centerScroll + rect.height / 3;

      if (scroll < topScroll) {
        setState(SnapState.BEFORE);
      } else if (scroll > bottomScroll) {
        setState(SnapState.AFTER);
      } else {
        setState(SnapState.SNAPPED);
      }
    };

    handleScroll();
    return () => {
      cancelAnimationFrame(animationFrame);
    };
  }, []);

  return { ref, state };
};
